(ns portal.advertiser-configuration-page.view.backup
  (:require ["@mui/material/Box$default" :as Box]
            [common.queries :refer [use-query]]
            [common.resource.query.advertiser :as q]
            [portal.backup-image-table.view :as backup-image-table]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui backup-image-tab []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {advertiser :data} (use-query (q/advertiser-query {:advertiser-id advertiser-id}))]
    (if-not (seq (:backupLandingPageUrl advertiser))
      ($ Box
         {:sx #js {:px 3
                   :pt 3}}
         "Please define a Backup URL, before you can upload Backup Images.")
      ($ backup-image-table/table))))
